module.exports = __webpack_public_path__ + "assets/img/btn-back-e629feda.png";